import { UPDATE_CARD_DETAILS } from '../../types';

const initialstate = {
    visitingCardDetails: {
        name: 'John O Corner',
        designation: 'Life Coach and Trainer',
        email: 'joconor@memphis.com',
        phone: '+1 00 20212121',
        linkedin: 'linkedin.com/johnthetrainer',
        website: 'memphislife.com',
        about: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
        intrest: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat'
    }
};

export default (state: any = initialstate, action: any) => {
    switch (action.type) {
        case UPDATE_CARD_DETAILS:
            return {
                ...state,
                visitingCardDetails: action.payload
            }
        default:
            return state;
    }
};